import React, { useEffect, useRef, useState } from "react";
import axios from "axios";

const API_URL = "https://sdi909uolk.execute-api.ap-south-1.amazonaws.com";
const HOUSEHOLD_ID = "sabari-household";
const CATEGORIES = [
  "Recharge", "Food", "Tea / Coffee", "Fruits / Juice", "Petrol", "Transport", "Milk", "Groceries",
  "Sports", "Guest expense", "Haircut", "Medicine", "Clothes", "Electricity bill", "Fuel", "Snacks",
  "Trip / Vacation", "Movie", "Other",
];

function Categorize({ expenses, token, onDone }) {
  const uncategorized = expenses.filter((e) => e.category === "Uncategorized");

  const merchantTotals = {};
  uncategorized.forEach((e) => {
    merchantTotals[e.merchant_name] = (merchantTotals[e.merchant_name] || 0) + parseFloat(e.amount);
  });
  const uniqueMerchants = Object.keys(merchantTotals).sort((a, b) => merchantTotals[b] - merchantTotals[a]);

  const [index, setIndex] = useState(0);
  const [saving, setSaving] = useState(false);
  const [customCategory, setCustomCategory] = useState("");
  const [needsCustomCategory, setNeedsCustomCategory] = useState(false);
  const customInputRef = useRef(null);

  useEffect(() => {
    if (needsCustomCategory) customInputRef.current?.focus();
  }, [needsCustomCategory]);

  if (uniqueMerchants.length === 0) {
    return (
      <div className="subpage done-screen">
        <h2 className="subpage-title">🎉 Nothing left to categorize!</h2>
        <button className="btn btn-dark" onClick={onDone}>Back to dashboard</button>
      </div>
    );
  }
  if (index >= uniqueMerchants.length) {
    return (
      <div className="subpage done-screen">
        <h2 className="subpage-title">All done!</h2>
        <p>Refresh to see your updated dashboard.</p>
        <button className="btn btn-dark" onClick={onDone}>Back to dashboard</button>
      </div>
    );
  }

  const merchant = uniqueMerchants[index];
  const countForMerchant = uncategorized.filter((e) => e.merchant_name === merchant).length;

  const pick = async (category) => {
    setSaving(true);
    await axios.post(
      `${API_URL}/categorize`,
      { household_id: HOUSEHOLD_ID, merchant_name: merchant, category },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    setSaving(false);
    setIndex(index + 1);
  };

  const addCustomCategory = () => {
    const category = customCategory.trim();
    if (category) pick(category);
  };

  const chooseCategory = (category) => {
    if (category === "Other") {
      setNeedsCustomCategory(true);
      return;
    }
    pick(category);
  };

  return (
    <div className="subpage">
      <button className="btn" onClick={onDone} style={{ marginBottom: 16 }}>← Back to dashboard</button>
      <p className="progress-text">Reviewing merchant {index + 1} of {uniqueMerchants.length}</p>
      <h1 className="subpage-title categorize-title">Review categories</h1>
      <h2 className="merchant-name">{merchant}</h2>
      <p className="merchant-count">This choice will update {countForMerchant} uncategorized transaction{countForMerchant > 1 ? "s" : ""} · ₹{merchantTotals[merchant].toFixed(2)}</p>

      <div className="chip-row">
        {CATEGORIES.map((cat) => (
          <button key={cat} className={`chip-btn ${cat === "Other" ? "other-category-btn" : ""}`} disabled={saving} onClick={() => chooseCategory(cat)}>
            {cat}
          </button>
        ))}
      </div>

      <div className="custom-category-row">
        <div className="custom-category-field">
          {needsCustomCategory && <label className="custom-category-prompt" htmlFor="custom-category">What type of expense is this?</label>}
          <input id="custom-category" ref={customInputRef} className="field-input" value={customCategory} onChange={(event) => setCustomCategory(event.target.value)} placeholder={needsCustomCategory ? "Type the category, e.g. Home repair" : "Add another category, e.g. Rent"} aria-label="Custom category" />
        </div>
        <button className="btn" disabled={saving || !customCategory.trim()} onClick={addCustomCategory}>Apply</button>
      </div>

      <div className="categorize-actions">
        <button className="btn" disabled={index === 0 || saving} onClick={() => setIndex(index - 1)}>← Previous</button>
        <button className="btn" disabled={saving} onClick={() => setIndex(index + 1)}>Skip for now →</button>
      </div>
    </div>
  );
}

export default Categorize;
